import React from 'react';
import {env} from 'config/env';

const VersionBadge: React.FC = () => {
  const githubBaseURL = 'https://github.com/ZeptaIO/zcontrol-backoffice/commit/';
  const version = env.version;

  if (!version) {
    return null;
  }

  return (
    <a onClick={() => window.open(githubBaseURL + version)} target="_blank">
      <small className="badge text-bg-primary text-white">{version}</small>
    </a>
  );
};

export default VersionBadge;
